import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { getOrganizationSidebarConfig } from "src/staticData";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug")({
  component: RouteComponent,
  ssr: true,
  beforeLoad() {
    return loaderHandler((ctx) => {
      if (!ctx.session?.entitlements.canAccessOrganizations) {
        throw redirect({ to: "/" });
      }
    });
  },
  loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      () => {
        return { data: null };
      },
    );
  },
  staticData: {
    getLayoutSettings(ctx) {
      return {
        requiresCoachSubscription: false,
        sidebar: getOrganizationSidebarConfig(ctx, ctx.params.slug),
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
